module.exports = __webpack_public_path__ + "img/amazon-s3.d0ff30e0.svg";